var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("path", {
      attrs: {
        fill: _vm.color1,
        d: "M8 2.067C5.90133 -1.37061 0 -0.367076 0 3.94044C0 6.90651 3.714 9.93939 8 14C12.2867 9.93939 16 6.90651 16 3.94044C16 -0.381712 10.0833 -1.34516 8 2.067Z",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }